import { refreshFetch } from './axios';
import { logger } from 'utils';

// TODO: Combine getLoanContract & getExtensionContract (ideally should be one method);
export const getLoanContract = async (link: string) => {
  const axios = refreshFetch();
  const endpoint = link;
  const response = await axios({
    method: 'get',
    headers: { accept: 'application/pdf' },
    url: endpoint,
  });

  logger('getContract response', response);
  return response;
};

export const getExtensionContract = async (link: string) => {
  const axios = refreshFetch();
  const endpoint = link;
  const response = await axios({
    method: 'get',
    headers: { accept: 'application/pdf' },
    url: endpoint,
    responseType: 'blob',
  });

  logger('getContract response', response);
  return response;
};

export const getContractPreview = async (link: string) => {
  const axios = refreshFetch();
  const endpoint = link;
  const response = await axios({
    method: 'get',
    headers: { accept: 'text/html' },
    url: endpoint,
  });

  logger('getContract response', response);
  return response;
};

export const getContract = async (url: string) => {
  const axios = refreshFetch();
  const response = await axios({
    method: 'get',
    headers: { accept: 'application/pdf' },
    url,
    responseType: 'blob',
  });
  logger('getContract response', response);
  return response;
};
